<template>
  <div>
    <div style="margin: 50px; background-color: white">
      <div class="title">服务资讯维护</div>
      <div class="table-data">
        <el-button type="primary" @click="add()">新增</el-button>
        <el-table :data="tableData" border stripe>
          <el-table-column prop="id" label="ID"> </el-table-column>
          <el-table-column prop="imgUrl" label="图片">
            <template slot-scope="scope">
              <img :src="scope.row.imgUrl" />
            </template>
          </el-table-column>
          <el-table-column prop="title" label="文章标题"> </el-table-column>
          <el-table-column prop="url" label="文章地址"> </el-table-column>
          <el-table-column prop="releaseTime" sortable label="发布时间">
          </el-table-column>
          <el-table-column prop="createTime" sortable label="创建时间">
          </el-table-column>
          <el-table-column label="操作" width="50">
            <template slot-scope="scope">
              <el-link @click="deleteClick(scope.row)" type="danger"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        title="新增服务资讯"
        :visible.sync="dialogVisible"
        :show-close="false"
        width="50%"
      >
        <el-form :model="form" ref="form" :rules="rules">
          <el-form-item label="文章标题" prop="title">
            <el-input style="width: 70%" v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="文章地址" prop="url">
            <el-input style="width: 70%" v-model="form.url"></el-input>
          </el-form-item>
          <el-form-item label="发布时间" prop="releaseTime">
            <el-input
              style="width: 70%"
              v-model="form.releaseTime"
              placeholder="格式：xxxx-xx-xx"
            ></el-input>
          </el-form-item>
          <el-form-item label="文章图片">
            <el-upload
              class="upload-demo"
              drag
              :action="uploadUrl"
              :before-upload="beforeUploadImg"
              :on-success="uploadImgSuccess"
              :limit="1"
              ref="imgRef"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <!-- <div class="el-upload__tip" slot="tip">
              只能上传jpg/png文件，且不超过500kb
            </div> -->
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancel()">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import api from "../common/utils/api";
import http from "axios";
export default {
  data() {
    return {
      uploadUrl: api.serviceInformation.uploadFile(),
      dialogVisible: false,
      form: {
        title: "",
        imgUrl: "",
        url: "",
        releaseTime: "",
      },
      rules: {
        title: [{ required: true, message: "请填写文章标题", trigger: "blur" }],
        url: [{ required: true, message: "请填写文章地址", trigger: "blur" }],
        releaseTime: [
          { required: true, message: "请填写发布时间", trigger: "blur" },
        ],
      },
      tableData: [],
    };
  },
  methods: {
    /**
     * 照片成功处理
     */
    uploadImgSuccess(response, file, fileList) {
      this.form.imgUrl = response.data;
    },

    /**
     * 上传照片验证
     */
    beforeUploadImg(file) {
      const isLt20M = file.size / 1024 / 1024 < 10;
      var fileSrc = file.name.substring(file.name.lastIndexOf(".") + 1);
      const isImg =
        fileSrc === "jpg" ||
        fileSrc === "png" ||
        fileSrc === "jpeg" ||
        fileSrc === "JPG" ||
        fileSrc === "PNG" ||
        fileSrc === "JPEG";
      if (!isLt20M) {
        alert("照片大小不能超过10MB");
      }
      if (!isImg) {
        alert("只能上传jpg，png, jpeg格式");
      }
      return isLt20M && isImg;
    },

    cancel() {
      this.form = {
        title: "",
        imgUrl: "",
        url: "",
        releaseTime: "",
      };
      this.$refs.imgRef.clearFiles();
      this.dialogVisible = false;
      this.$refs["form"].clearValidate();
    },

    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.imgUrl == "") {
            alert("请上传文章图片");
            return false;
          }
          let url = api.serviceInformation.add();
          http
            .post(url, this.form)
            .then((res) => {
              if (res.data.stateCode !== 1) {
                alert(res.data.message);
              } else {
                alert("添加成功");
                this.getListData();
                this.cancel();
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    add() {
      this.dialogVisible = true;
      this.$refs.imgRef.clearFiles();
      this.form = {
        title: "",
        imgUrl: "",
        url: "",
        releaseTime: "",
      };
    },

    getListData() {
      let url = api.serviceInformation.getList()+ '?t=' + new Date().getTime();
      http.get(url).then((res) => {
        this.tableData = res.data.data.list;
      });
    },
    deleteClick(row) {
      var ok = confirm("确认删除？");
      if (!ok) {
        return;
      }
      let url = api.serviceInformation.delete();
      http.get(url, { params: { id: row.id } }).then((res) => {
          if(res.data.stateCode == 1) {
            alert("删除成功")
          } else {
            alert(res.data.message)
          }
          this.getListData();
      });
    },
  },
  created() {
    this.getListData();
    var getHeader = document.getElementById("getHeader");
    var getFooter = document.getElementById("getFooter");
    getHeader.remove();
    getFooter.remove();
  },
};
</script>

<style>
.title {
  text-align: center;
  font-size: 40px;
  font-weight: 800;
}
.table-data {
  width: 100%;
  padding: 10px;
  margin: auto;
}
</style>